export default __webpack_public_path__ + "static/media/thailand.3f1a6ec4.jpg";